import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableClients = Loadable({
  loader: function loader() {
    return import('../Clients/Clients.jsx');
  },
  loading: ComponentLoading
});
export default LoadableClients;